const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

type TIsEmailValid = (email: string) => boolean

export const isEmailValid: TIsEmailValid = email =>
  Boolean(email.match(new RegExp(EMAIL_REGEXP)))
